module.exports = __webpack_public_path__ + "img/1.040efa4e.jpg";